import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LearnMore } from './learn-more';
import './qbo.scss';
import { Button } from '../components/form/button';
import { Disconnect } from './disconnect';
import { Launch } from './launch';

export const BookADemoButton = () => {
  return (
    <Button className="button button-yellow" onClick={() => (window.location.href = 'https://quipli.com/book-a-demo')}>
      <span className="font-bold text-[1.1rem] px-[1.5rem] py-[.5rem]">Book a Demo</span>
    </Button>
  );
};

export const QBO = () => {
  document.title = 'QuickBooks & Quipli';
  return (
    <div className="quipli-v2 p-1 md:px-[10%] md:py-8 bg-white qbo">
      <div className="rounded-2xl bg-[#1d252c] min-h-[calc(100vh-4rem)] relative">
        <img className="absolute top-[8rem] hidden md:inline" src={'/static/img/banner-vector.svg'} />
        <div className="rounded-2xl border-solid border-[1px] border-gray-300 p-4 bg-white flex justify-between items-center">
          <a href="https://quipli.com">
            <img src={'/static/img/Quipli-logo.svg'} />
          </a>
          <div className="flex items-center gap-8">
            <a href="tel:8329792147" className="text-black hidden md:inline">
              (832) 979-2147
            </a>
            <BookADemoButton />
          </div>
        </div>
        <img
          className="right-vector absolute top-[28rem] right-[0] hidden md:inline"
          src={'/static/img/banner-vector.svg'}
        />
        <Routes>
          <Route path={'/learn-more'} element={<LearnMore />} />
          <Route path={'/disconnect'} element={<Disconnect />} />
          <Route path={'/launch'} element={<Launch />} />
        </Routes>
      </div>
    </div>
  );
};
